import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./main.css";

class Main extends Component {
  render() {
    return (
      <nav className="main-menu">
        <ul className="menu">
          <li className="menu-item">
            <div className="menu-item-tag ">
              <div className="menu-item-hover-fix" />
              <div className="menu-item-hover-fix" /> Purchase Order Maintenance{" "}
            </div>
            <ul className="sub-menu">
              <li>
                <Link to="/poheader" className="sub-menu-item-tag">
                  Manage POs
                </Link>
              </li>
              <li>
                <Link to="/override_asn/view_override_asn" className="sub-menu-item-tag">
                  Override ASN
                </Link>
              </li>
            </ul>
          </li>
          <li className="menu-item">
            <div className="menu-item-tag ">
              <div className="menu-item-hover-fix" />
              <div className="menu-item-hover-fix" /> Item Maintenance{" "}
            </div>
            <ul className="sub-menu">
              <li>
                <Link
                  to="/item_maintenance/manage_item-vendor_information_by_dc"
                  className="sub-menu-item-tag"
                >
                  Manage Item-Vendor Information by DC
                </Link>
              </li>
              <li>
                <Link
                  to="/item_maintenance/manage_item_information_by_dc"
                  className="sub-menu-item-tag"
                >
                  Manage Item Information by DC
                </Link>
              </li>
              <li>
                <Link
                  to="/item_maintenance/manage_item_volumetric_information_by_dc"
                  className="sub-menu-item-tag"
                >
                  Manage Item Volumetric Information by DC
                </Link>
              </li>
              <li>
                <Link
                  to="/item_maintenance/view_item_shipment_history_by_dc"
                  className="sub-menu-item-tag"
                >
                  View Item Shipment History by DC
                </Link>
              </li>
              <li>
                <Link
                  to="/item_maintenance/view_item_information_item_level"
                  className="sub-menu-item-tag"
                >
                  View Item Information (Item Level)
                </Link>
              </li>
            </ul>
          </li>
          <li className="menu-item">
            <div className="menu-item-tag ">
              <div className="menu-item-hover-fix" />
              <div className="menu-item-hover-fix" /> Vendor Maintenance
            </div>
            <ul className="sub-menu">
              <li>
                <Link
                  to="/vendor_maintenance/manage_vendor_information_by_dc"
                  className="sub-menu-item-tag"
                >
                  Manage Vendor Information by DC
                </Link>
              </li>
              <li>
                <Link
                  to="/vendor_maintenance/view_vendor_information_by_dc_di_vendors"
                  className="sub-menu-item-tag"
                >
                  View Vendor Information by DC (DI Vendors)
                </Link>
              </li>
              <li>
                <Link
                  to="/vendor_maintenance/view_vendor_information_by_number"
                  className="sub-menu-item-tag"
                >
                  View Vendor Information by Number
                </Link>
              </li>
              <li>
                <Link
                  to="/item_maintenance/view_vendor_level_information_by_number"
                  className="sub-menu-item-tag"
                >
                  View Vendor-Level Information by Number
                </Link>
              </li>
              <li>
                <Link
                  to="/item_maintenance/view_vendor_level_information_by_name"
                  className="sub-menu-item-tag"
                >
                  View Vendor-Level Information by Name
                </Link>
              </li>
            </ul>
          </li>
          <li className="menu-item">
            <div className="menu-item-tag ">
              <div className="menu-item-hover-fix" />
              <div className="menu-item-hover-fix" /> Manage Forecast
              Replenishment{" "}
            </div>
            <ul className="sub-menu">
              <li>
                <Link
                  to="/manage_forecast_replenishment/manage_item_forecast_replenishment_by_dc"
                  className="sub-menu-item-tag"
                >
                  Manage Item Forecast Replenishment by DC
                </Link>
              </li>
              <li>
                <Link
                  to="/manage_forecast_replenishment/manage_vendor_forecast_replenishment_by_dc"
                  className="sub-menu-item-tag"
                >
                  Manage Vendor Forecast Replenishment by DC
                </Link>
              </li>
            </ul>
          </li>
          <li className="menu-item">
            <div className="menu-item-tag ">
              <div className="menu-item-hover-fix" />
              <div className="menu-item-hover-fix" /> Yard Management
            </div>
            <ul className="sub-menu">
              <li>
                <Link
                  to="/yard_management/view_di_yard_management"
                  className="sub-menu-item-tag"
                >
                  View DI Yard Management System Tracking
                </Link>
              </li>
            </ul>
          </li>
          <li className="menu-item">
            <div className="menu-item-tag ">
              <div className="menu-item-hover-fix" />
              <div className="menu-item-hover-fix" /> Alternate Vendor
            </div>
            <ul className="sub-menu">
              <li>
                <Link
                  to="/alternate_vendor/view_alternate_vendor"
                  className="sub-menu-item-tag"
                >
                  View Alternate Vendor
                </Link>
              </li>
            </ul>
          </li>
          <li className="menu-item">
            <div className="menu-item-tag ">
              <div className="menu-item-hover-fix" />
              <div className="menu-item-hover-fix" /> MOQ Maintenance
            </div>
            <ul className="sub-menu">
              <li>
                <Link
                  to="/moq_maintenance/view_moq_maintenance"
                  className="sub-menu-item-tag"
                >
                  View MOQ Maintenance
                </Link>
              </li>
            </ul>
          </li>
          {/* <li className="menu-item">
            <div className="menu-item-tag ">
              <div className="menu-item-hover-fix" />
              <div className="menu-item-hover-fix" /> Reports
            </div>
          </li> */}
        </ul>
      </nav>
    );
  }
}

export default Main;
